<template lang="pug">
  .d-header
    .cont
      .logo
        img(src="~assets/header/logo.png")
      .right
        .item 
          router-link(to="/index")
            span 关于懂窝
        .item
          router-link(to="/findUs")
            span 找到我们
        .item
          router-link(to="/lifeHome")
            span 懂窝生活家
</template>

<script>
  export default {
    data() {
      return {
      }
    },
  }
</script>

<style lang="sass" scoped>
@import 'config'
.router-link-active
  border-bottom: 2px solid #070809
.d-header
  position: fixed
  top: 0
  z-index: 200
  width: 100%
  height: r(66)
  background: #FFFFFF
  font-family: PingFangSC-Medium;
  .cont
    margin: 0 auto
    width: 84%
    height: 100%
    display: flex
    justify-content: space-between
    .logo
      height: 100%
      padding-top: r(2)
      img
        margin-top: r(6)
        display: block
        width: r(64)
    .right
      width: r(450)
      height: 100%
      display: flex
      justify-content: space-between
      .item
        font-size: r(20)
        line-height: r(66)
        span
          color: #070809
</style>


// WEBPACK FOOTER //
// header.vue?c58f5e30